// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"eaa0bd39","413":"eaa0bd39","874":"eaa0bd39"}[chunkId] + ".chunk.css";
};